export const ROUTES = {
  // Public
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  VERIFY_EMAIL: '/verify-email',
  RESET_PASSWORD: '/reset-password',
  ONBOARDING: '/onboarding',

  // Core
  HOME: '/discover',
  ASSOCIATIONS: '/associations',
  MEMBERS: '/members',
  CIRCLES: '/circles',
  DISCOVER: '/discover',

  // Finance (consolidated)
  FINANCES: '/finances',
  TREASURY: '/treasury',

  // Governance
  GOVERNANCE: '/governance',
  GOVERNANCE_VOTE: '/governance/vote/:id',

  // Content
  DOCUMENTS: '/documents',
  PROJECTS: '/projects',
  PROJECT_DONATE: '/projects/:id/donate',

  // Communication (split)
  MESSAGES: '/messages',
  EVENTS: '/events',
  EVENTS_CREATE: '/events/create',

  // Social
  COMMUNITY: '/community',
  CREDIT: '/credit',

  // Intelligence (merged)
  ANALYTICS: '/analytics',

  // B2B
  B2B: '/b2b',
  RELATIONSHIPS: '/relationships',

  // Organization
  FEDERATIONS: '/federations',

  // Network Graph
  NETWORK: '/network',

  // Admin
  ADMIN: '/admin',

  // User
  PROFILE: '/profile',
  SETTINGS: '/settings',
  HELP: '/help',
} as const

// Builder functions for parameterized routes
export function governanceVotePath(id: string) {
  return `/governance/vote/${encodeURIComponent(id)}` as const
}

export function projectDonatePath(id: string) {
  return `/projects/${encodeURIComponent(id)}/donate` as const
}

// Query-param builders for pages with view state
export function associationsPath(params?: { view?: string; id?: string; memberId?: string }) {
  return buildPath(ROUTES.ASSOCIATIONS, params)
}

export function circlesPath(params?: { view?: string; id?: string; assocId?: string }) {
  return buildPath(ROUTES.CIRCLES, params)
}

export function membersPath(params?: { view?: string; id?: string }) {
  return buildPath(ROUTES.MEMBERS, params)
}

export function financesPath(params?: { tab?: string; subtab?: string; circleId?: string }) {
  return buildPath(ROUTES.FINANCES, params)
}

export function governancePath(params?: { view?: string; id?: string; type?: string }) {
  return buildPath(ROUTES.GOVERNANCE, params)
}

export function analyticsPath(params?: { tab?: string }) {
  return buildPath(ROUTES.ANALYTICS, params)
}

export function messagesPath(params?: { tab?: string; conversationId?: string }) {
  return buildPath(ROUTES.MESSAGES, params)
}

export function eventsPath(params?: { view?: string; id?: string }) {
  return buildPath(ROUTES.EVENTS, params)
}

export function b2bPath(params?: { view?: string; id?: string }) {
  return buildPath(ROUTES.B2B, params)
}

export function networkPath(params?: { scope?: string; entityId?: string }) {
  return buildPath(ROUTES.NETWORK, params)
}

export function adminPath(params?: { section?: string; tab?: string }) {
  return buildPath(ROUTES.ADMIN, params)
}

export function profilePath(params?: { tab?: string }) {
  return buildPath(ROUTES.PROFILE, params)
}

// Helper: build a path with query params, omitting null/undefined values
function buildPath(base: string, params?: Record<string, string | null | undefined>): string {
  if (!params) return base
  const search = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (value != null) search.set(key, value)
  }
  const qs = search.toString()
  return qs ? `${base}?${qs}` : base
}
